<p>test-user works!</p>
<mat-form-field>
  <mat-label>Välj användare</mat-label>
  <mat-select [formControl]="control">
    <mat-option [value]="null"></mat-option>
    <mat-option *ngFor="let user of testUsers" [value]="user">{{ user.name }}</mat-option>
  </mat-select>
</mat-form-field>